export const extendsList = [
  {
    type: 'ketcher_extend_list_upload',
    icon: 'upload',
    name: '上传分子图片'
  }
]
